jQuery(document).ready(function ($) {
    var header = $('header.banner');
    var sticky = $(window).scrollTop();
    var wrapper = $('body > .wrap.container');
    var win = $(window);

    if(sticky != 0) {
        header.addClass('sticky');
    }

    win.on("scroll", function() {
        var sticky = $(window).scrollTop();
        if (sticky !== 0) {
            header.addClass("sticky");
        } else {
            header.removeClass("sticky");
            wrapper.css('padding-top', '0');
        }
    });

});
// window.addEventListener("scroll", function() {
//     var sticky = window.pageYOffset;
//     let lastScroll = 0;
//     if (sticky <= 0) {
//         header.removeClass("sticky hide");
//         return;
//       }
//     if(sticky < lastScroll){
//         header.addClass("sticky"); 
//     }else if(sticky > lastScroll){
//         header.addClass("hide")
//     }
//     lastScroll = sticky; 
// });


// WEBPACK FOOTER //
// ./scripts/custom/sticky-header.js